import { axios } from '@/utils/request'

export function pageUser (query) {
  return axios({
    url: '/users',
    method: 'get',
    params: query
  })
}

export function createUser (form) {
  return axios({
    url: '/user',
    method: 'post',
    data: form
  })
}

export function updateUser (id, form) {
  return axios({
    url: '/user/' + id,
    method: 'put',
    data: form
  })
}

export function updatePassword (form) {
  return axios({
    url: '/user/password',
    method: 'patch',
    data: form
  })
}

export function updateAvatar (id, avatarUrl) {
  return axios({
    url: '/user/' + id + '/avatar',
    method: 'patch',
    params: {
      avatarUrl
    }
  })
}

export function restorePassword (id) {
  return axios({
    url: '/user/' + id + '/password',
    method: 'patch'
  })
}

export function setEnabled (id, enabled) {
  return axios({
    url: '/user/' + id,
    method: 'patch',
    params: { enabled: enabled }
  })
}

export function removeUser (id) {
  return axios({
    url: '/user/' + id,
    method: 'delete'
  })
}

export function listRoles () {
  return axios({
    url: '/roles',
    method: 'get'
  })
}